import './../../scss/components/search.scss'

function autocomplete(inp) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function(e) {
        var a, val = this.value;

        if (val.length < 2) return false;

        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false;}
        currentFocus = -1;

        getData(this, val);
    });
    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
        }
        else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            if (currentFocus > -1) {
                e.preventDefault();
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
            }
        }
    });

    function getData(input, search) {
        axios({
            method: 'post',
            url: '/recherche',
			data: {search: search},
        }).then(function (response) {
            if (response.status == 200) {
                let arr = response.data;

                /*create a DIV element that will contain the items (values):*/
                let div = document.createElement("div");
                div.setAttribute("id", input.id + "autocomplete-list");
                div.setAttribute("class", "autocomplete-items");
                /*append the DIV element as a child of the autocomplete container:*/
                input.parentNode.appendChild(div);

                /*for each item in the array...*/
                for (let i = 0; i < arr.length; i++) {
                    /*check if the item starts with the same letters as the text field value:*/
                    /*create a DIV element for each matching element:*/
                    let a = document.createElement("a");
                    a.href = arr[i].route;
                
                    /*make the matching letters bold:*/
                    let re = new RegExp(search, "ig"); // search for all instances
                    let text = arr[i].name
                    text = text.replace(re, `<strong>${search}</strong>`);
                    let reference = arr[i].reference.replace(re, `<strong>${search}</strong>`);
                    text = '<span>' + text + '</span><br />';
                    text += '<small>Réf. : ' + reference + '</small>';
                    
                    
                    a.innerHTML = text;

                    div.appendChild(a);
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
            x[i].parentNode.removeChild(x[i]);
        }
    }
  }
  /*execute a function when someone clicks in the document:*/
  document.addEventListener("click", function (e) {
      closeAllLists(e.target);
  });
}
let autocompleteBlock = document.getElementById("autoComplete");
if (autocompleteBlock) {
    autocomplete(autocompleteBlock);
}
